import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useCallback,
  useState,
} from "react";
import equal from "deep-equal";

interface MapSettingsContextSettings {
  [key: string]: unknown;
}
interface MapSettingsContextType {
  settings: MapSettingsContextSettings;
  setSetting?: (key: string, value: unknown) => void;
}

export const MapSettingsContext = createContext<MapSettingsContextType>({
  settings: {},
});

const MapSettingsContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [settings, setSettings] = useState<MapSettingsContextSettings>({});

  const setSetting = useCallback(
    (key: string, value: unknown) => {
      setSettings((prev) => ({
        ...prev,
        [key]: equal(prev[key], value) ? undefined : value,
      }));
    },
    [setSettings],
  );

  return (
    <MapSettingsContext.Provider value={{ settings, setSetting }}>
      {children}
    </MapSettingsContext.Provider>
  );
};

export default MapSettingsContextProvider;
